import {createContext, Dispatch, Key, SetStateAction} from 'react';

import {ERequestFormFormKey} from './request-form.constants';

export interface IRequestFormContextArgs {
    selectedTabKey: ERequestFormFormKey | Key;
    setSelectedTabKey: Dispatch<SetStateAction<Key | ERequestFormFormKey>> | null;
    entityName: string;
}

export const RequestFormContext = createContext<IRequestFormContextArgs>({
    selectedTabKey: ERequestFormFormKey.REQUESTS,
    setSelectedTabKey: null,
    entityName: '',
});
